export const SPACES_POSTER_POSITIONS = {
  OFFICE_PLATFORM_NORMAL: {
    "0": { position: { x: -25, y: 1, z: 38 } },
    "1": { position: { x: 0, y: 0, z: 37 } },
    "2": { position: { x: -20, y: 3, z: 52 } },
    "3": { position: { x: -2, y: 2, z: 52 } },
  },
  GAMING_PLATFORM: {
    "0": { position: { x: -28, y: 0, z: 40 } },
    "1": { position: { x: 8, y: 1, z: 40 } },
    "2": { position: { x: 25, y: 2, z: 65 } },
    "3": { position: { x: 36, y: 3, z: 65 } },
  },
  LEARNING_PLATFORM: {
    "0": { position: { x: 5, y: 0, z: 35 } },
    "1": { position: { x: -45, y: 1, z: -15 } },
    "2": { position: { x: -3.5, y: 2, z:- 15 } },
  }, 
  OFFICE_PLATFORM_NORMAL_TWO: {
    "0": { position: { x: 9, y: 0, z: -7 } },
    "1": { position: { x: 9, y: 0, z: 10 } },
    "2": { position: { x: -91, y: 0, z: 30 } },
    "3": { position: { x: -91, y: 0, z: 2 } },
    "4": { position: { x: -91, y: 0, z: -25 } },
    "5": { position: { x: 50, y: 0, z: 30 } }, 
    "6": { position: { x: 50, y: 0, z: 2 } }, 
    "7": { position: { x: 50, y: 0, z: -25 } },
  },
  SHOWROOM_NETWORKING: {
    "0": { position: { x: 23.5, y: 3.56, z: 5 } },
    "1": { position: { x: 23.5, y: 3.56, z: -5 } },
  },
  SHOWROOM_SUPER_OFFICE: {
    "0": { position: { x: 24, y: 3.56, z: 4 } },
    "1": { position: { x: 24, y: 3.56, z: -4 } },
  }, 
  SHOWROOM_INVESTIGATION: {
    "0": { position: { x: 24, y: 3.56, z: 4 } },
    "1": { position: { x: 24, y: 3.56, z: -4 } },
  }, 
  SHOWROOM_SUPER_BIG_WITH_NETWORKING_NO_WALL: {
    "0": { position: { x: 24, y: 3.56, z: 4.5 } },
    "1": { position: { x: 24, y: 3.56, z: -4.6 } },
  }, 
  SHOWROOM_FOREST: {
    "0": { position: { x: -1.5, y: 3.56, z: 3 } },
    "1": { position: { x: -1.5, y: 3.56, z: -3 } },
    "2": { position: { x: 4.5, y: 3.56, z: 3 } },
    "3": { position: { x: 4.5, y: 3.56, z: -3 } },
    "4": { position: { x: 11, y: 3.56, z: 3 } },
    "5": { position: { x: 11, y: 3.56, z: -3 } },
  },
  SHOWROOM_OASIS: {
    "0": { position: { x: -8.5, y: 3.56, z: -4.5 } },
    "1": { position: { x: 8, y: 3.56, z: -4.5 } },
    "2": { position: { x: -8.5, y: 3.56, z: 8.5 } },
    "3": { position: { x: 8, y: 3.56, z: 8.5 } },
  },
  SPACE_ISLANDS: {
    "0": { position: { x: -0, y: 3.56, z: -2.5 } },
    "1": { position: { x: 5, y: 3.56, z: -2.5 } },
    "2": { position: { x: -0, y: 3.56, z: 0 } },
    "3": { position: { x: 5, y: 3.56, z: 0 } },
    "4": { position: { x: 20.5, y: 3.56, z: -1.1 } },
    "5": { position: { x: 18.5, y: 3.56, z: 3.5 } },
    "6": { position: { x: 1, y: 3.56, z: 5.5 } },
    "7": { position: { x: 4, y: 3.56, z: 5.5 } },
    "8": { position: { x: 1, y: 3.56, z: 7.5 } },
    "9": { position: { x: 4, y: 3.56, z: 7.5 } },
    "10": { position: { x: -19, y: 3.56, z: -2.1 } },
    "11": { position: { x: -16, y: 3.56, z: -2.1 } },
    "12": { position: { x: -19, y: 3.56, z: 0 } },
    "13": { position: { x: -16, y: 3.56, z: 0 } },
    "14": { position: { x: 2.5, y: 3.56, z: -7.5 } },
  },   
  SPACE_ISLANDS_XRF: {
    "0": { position: { x: -0, y: 3.56, z: -2.5 } },
    "1": { position: { x: 5, y: 3.56, z: -2.5 } },
    "2": { position: { x: -0, y: 3.56, z: 0 } },
    "3": { position: { x: 5, y: 3.56, z: 0 } },
    "4": { position: { x: 20.5, y: 3.56, z: -1.1 } },
    "5": { position: { x: 18.5, y: 3.56, z: 3.5 } },
    "6": { position: { x: 1, y: 3.56, z: 5.5 } },
    "7": { position: { x: 4, y: 3.56, z: 5.5 } },
    "8": { position: { x: 1, y: 3.56, z: 7.5 } },
    "9": { position: { x: 4, y: 3.56, z: 7.5 } },
    "10": { position: { x: -19, y: 3.56, z: -2.1 } },
    "11": { position: { x: -16, y: 3.56, z: -2.1 } },
    "12": { position: { x: -19, y: 3.56, z: 0 } },
    "13": { position: { x: -16, y: 3.56, z: 0 } },
    "14": { position: { x: 2.5, y: 3.56, z: -7.5 } },
  },    
  CTTI_BURRA_CLUB: {
    "0": { position: { x: 0, y: 3.56, z: 4.7 } },
    "1": { position: { x: 0, y: 3.56, z: 2 } },
  },
  ENEB_SPACE_ISLANDS_BLUE: {
    "0": { position: { x: -2, y: 3.56, z: -2.6 } },
    "1": { position: { x: 2, y: 3.56, z: -2.6 } },
    "2": { position: { x: -2, y: 3.56, z: 0 } },
    "3": { position: { x: 2, y: 3.56, z: 0 } },
    "4": { position: { x: 15, y: 3.56, z: -2.6 } },
    "5": { position: { x: 19, y: 3.56, z: -2.6 } },
    "6": { position: { x: 15, y: 3.56, z: -1 } },
    "7": { position: { x: 19, y: 3.56, z: -1 } },
    "8": { position: { x: -2, y: 3.56, z: 5.5 } },
    "9": { position: { x: 2, y: 3.56, z: 5.5 } },
    "10": { position: { x: -2, y: 3.56, z: 7.5 } },
    "11": { position: { x: 2, y: 3.56, z: 7.5 } },
    "12": { position: { x: -19.5, y: 3.56, z: -2.6 } },
    "13": { position: { x: -16.5, y: 3.56, z: -2.6 } },
    "14": { position: { x: -19.5, y: 3.56, z: -0.5 } },
    "15": { position: { x: -16.5, y: 3.56, z: -0.5 } },
    "16": { position: { x: -0.5, y: 3.56, z: -8 } },
  }, 
  HESPERIDES_ISLANDS: {
    "0": { position: { x: -1.5, y: 3.56, z: -2.6 } },
    "1": { position: { x: 2.5, y: 3.56, z: -2.6 } },
    "2": { position: { x: -1.5, y: 3.56, z: 0 } },
    "3": { position: { x: 2.5, y: 3.56, z: 0 } },
    "4": { position: { x: 16.5, y: 3.56, z: -1.5 } },
    "5": { position: { x: 15, y: 3.56, z: 3.5 } },
    "6": { position: { x: 18, y: 3.56, z: 3.5 } },
    "7": { position: { x: 15, y: 3.56, z: 6 } },
    "8": { position: { x: 18, y: 3.56, z: 6 } },
    "9": { position: { x: -0.5, y: 3.56, z: 5.5 } },
    "10": { position: { x: 3, y: 3.56, z: 5.5 } },
    "11": { position: { x: -0.5, y: 3.56, z: 7.5 } },
    "12": { position: { x: 3, y: 3.56, z: 7.5 } },
    "13": { position: { x: -16.5, y: 3.56, z: 5 } },
    "14": { position: { x: -12.5, y: 3.56, z: 5 } },
    "15": { position: { x: -16.5, y: 3.56, z: 7.5 } },
    "16": { position: { x: -12.5, y: 3.56, z: 7.5 } },
    "17": { position: { x: -18, y: 3.56, z: -2.5 } },
    "18": { position: { x: -14, y: 3.56, z: -2.5 } },
    "19": { position: { x: -18, y: 3.56, z: 0 } },
    "20": { position: { x: -14, y: 3.56, z: 0 } },
    "21": { position: { x: 1, y: 3.56, z: -7.8 } },
  },   
};
